import { motion } from "framer-motion";
import React, { useEffect } from "react";
import { useNavAndFooter } from "../../hooks/navFooter";
import Footer from "../Footer/Footer";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import Nav from "../Nav/Nav";
import * as styles from "./Layout.module.css";

export default function Layout({ children }) {
  const data = useNavAndFooter();
  const navItems = data.allSanityNav.nodes[0].category;
  const logoArray = data.allSanityNav.nodes[0].image;
  const footerItems = data.allSanityFooter.nodes[0];
  const [width, getWidth] = React.useState(0);

  useEffect(() => {
    const handleResize = () => {
      getWidth(window.innerWidth);
    };
    getWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <main className={styles.wrapper}>
      {width > 600 ? (
        <Nav navItems={navItems} logo={logoArray} />
      ) : (
        <HamburgerMenu
          navItems={navItems}
          logo={logoArray}
          socialMedia={footerItems.socialmedia}
        />
      )}
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.15,
        }}
      >
        {children}
      </motion.section>
      <Footer
        copyright={footerItems.copyright}
        footeritems={footerItems.footeritems}
        socialmedia={footerItems.socialmedia}
      />
    </main>
  );
}
